import * as requests from '../api-request'
import getToken from '../get-token'

export const saveHistory = async (data, token, signal) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'pitch_deck/create_history', data, token, signal)
}

export const deleteHistory = async (data, token) => {
  token = token || (await getToken())
  // skip store data if there is no token provided
  if (!token) {
    throw Error('Token is required')
  }
  return requests.toJSON('POST', 'pitch_deck/delete_history', data, token)
}

export const getHistory = async (data, token) => {
  token = token || (await getToken())
  // skip store data if there is no token provided
  if (!token) {
    throw Error('Token is required')
  }
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `pitch_deck/get_history?${queryString}`, data, token)
}

export const getLatest = async (data, token) => {
  token = token || (await getToken())
  // skip store data if there is no token provided
  if (!token) {
    throw Error('Token is required')
  }
  // Append a timestamp to bust any browser or CDN cache on every load
  const queryString = requests.createQueryString({ ...data, _t: Date.now() })
  return requests.toJSON('GET', `pitch_deck/latest?${queryString}`, null, token)
}

export const generateTemplate = async (data, token) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'pitch_deck/generate_template', data, token)
}

export const getAvailableImageModels = async (token) => {
  token = token || (await getToken())
  return requests.toJSON('GET', 'pitch_deck/available_image_models', null, token)
}

export const calculateImageCredit = async (data, token) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'pitch_deck/calculate_image_credits', data, token)
}

export const createPdfExportJob = async (data, token) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'pitch_deck/export_pdf', data, token)
}

// createQueryString drops an undefined projectUuid (URLSearchParams would send "undefined").
export const getRunningPdfExport = async (data, token) => {
  token = token || (await getToken())
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `pitch_deck/running_pdf_export?${queryString}`, null, token)
}

export const getCompletedPdfs = async (data, token) => {
  token = token || (await getToken())
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `pitch_deck/completed_pdfs?${queryString}`, null, token)
}
